import {ProductTile as ProductTileFeature} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_tile.types';
import {ProductTrackingData, TrackProduct} from '@aboutyou/tracking';
import React from 'react';
import styled from 'styled-components';

export interface ProductTileTrackedProps {
  tile: ProductTileFeature;
  streamPosition: number;
  trackingData?: ProductTrackingData;
}

/**
 * @deprecated
 */
export const ProductTileDeprecatedTracked: React.FC<
  React.PropsWithChildren<ProductTileTrackedProps>
> = ({tile, streamPosition, trackingData, children}) => {
  const productId = tile?.product?.id;

  return (
    <StyledTrackProduct
      Comp={'li'}
      productTile={tile}
      streamPosition={streamPosition}
      trackingKey={productId}
      trackingData={trackingData}
      threshold={0.2}
      triggerOnce
      data-testid={`productTileTracker-${productId}`}
    >
      {children}
    </StyledTrackProduct>
  );
};

const StyledTrackProduct = styled(TrackProduct)`
  list-style: none;
`;
